var React = require('react');

function BlueTick (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("circle",{"cx":"12.5","cy":"12.5","r":"12.5","fill":"#7098F8","key":0}),React.createElement("path",{"fill":"#FFF","fillRule":"nonzero","d":"M9.153 17.19l-3.33-3.42a1.213 1.213 0 0 1 0-1.693 1.15 1.15 0 0 1 1.648 0l2.47 2.539 6.589-6.77a1.15 1.15 0 0 1 1.647 0 1.213 1.213 0 0 1 0 1.692L10.73 17.19a1.1 1.1 0 0 1-1.577 0z","key":1})]));
}

BlueTick.defaultProps = {"width":"25","height":"25","viewBox":"0 0 25 25"};

module.exports = BlueTick;

BlueTick.default = BlueTick;
